"use client";

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/shadcn/ui/alert-dialog";

import Image from "next/image";
import { PunchupButton } from "@/components/shared/PunchupButton";
import useFeatureAnnouncement from "@/hooks/featureAnnouncement/useFeatureAnnouncement";

export default function FeatureAnnouncementModal() {
  const { isOpen, content, close } = useFeatureAnnouncement();

  if (!isOpen || !content) return null;

  const { imageSrc, title, body, dismissCTA, actionCTA } = content;

  return (
    <AlertDialog open={isOpen}>
      <AlertDialogContent className="p-0 overflow-hidden max-w-xl">
        {/* Image */}
        {imageSrc && (
          <div className="relative w-full flex items-center justify-center pt-4">
            <Image
              src={imageSrc}
              alt="Feature Image"
              width={600}
              height={400}
              style={{
                maxWidth: "100%",
                height: "auto",
                width: "auto",
              }}
              sizes="(max-width: 768px) 100vw, 600px"
              priority
            />
          </div>
        )}
        {/* Content */}
        <div className="p-6">
          <AlertDialogHeader className="text-left">
            <AlertDialogTitle>{title}</AlertDialogTitle>
            <AlertDialogDescription className="text-base text-black">
              {body}
            </AlertDialogDescription>
          </AlertDialogHeader>

          <AlertDialogFooter className="mt-6 flex gap-3 sm:justify-between">
            <AlertDialogCancel asChild>
              <PunchupButton
                variant="outline"
                onClick={() => {
                  dismissCTA.action();
                  close();
                }}
              >
                {dismissCTA.textLabel}
              </PunchupButton>
            </AlertDialogCancel>

            <AlertDialogAction
              asChild
              onClick={() => {
                actionCTA.action();
                close();
              }}
            >
              <PunchupButton>{actionCTA.textLabel}</PunchupButton>
            </AlertDialogAction>
          </AlertDialogFooter>
        </div>
      </AlertDialogContent>
    </AlertDialog>
  );
}
